/**
 *
 * @param x
 * @return {*[]}
 */
export const justArray = x => Array.isArray(x) ? x : [x];